<div class="field-wrap">
    <exl-plain-text-input
        [autoPopulated]="isAutoPopulated"
        [input]="depositFormDataService.subtitle"
        [label]="'research.assetsubtitle.overline' | customTranslate"
    >
    </exl-plain-text-input>
</div>
